import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWizard } from '../contexts/WizardContext';
import Step1WalletConnection from './wizard/Step1WalletConnection';
import Step2BasicInfo from './wizard/Step2BasicInfo';
import Step3ValidationEngine from './wizard/Step3ValidationEngine';
import Step4ABIInput from './wizard/Step4ABIInput';
import Step5PolicyMapping from './wizard/Step5PolicyMapping';
import Step5_1OnChainConfig from './wizard/Step5_1OnChainConfig';
import Step6Summary from './wizard/Step6Summary';
import Step7Submission from './wizard/Step7Submission';
import './Wizard.css';

const Wizard: React.FC = () => {
  const {
    currentStep,
    totalSteps,
    wizardData,
    canGoNext,
    canGoBack,
    nextStep,
    prevStep,
  } = useWizard();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      wizardData.submissionSuccess &&
      wizardData.submittedChainId &&
      wizardData.submittedContractAddress
    ) {
      const timer = setTimeout(() => {
        navigate(
          `/dapps/${encodeURIComponent(wizardData.submittedChainId!)}/${encodeURIComponent(wizardData.submittedContractAddress!)}`,
          { replace: true }
        );
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [
    wizardData.submissionSuccess,
    wizardData.submittedChainId,
    wizardData.submittedContractAddress,
    navigate,
  ]);

  const progress = (currentStep / totalSteps) * 100;

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1WalletConnection />;
      case 2:
        return <Step2BasicInfo />;
      case 3:
        return <Step3ValidationEngine />;
      case 4:
        return <Step4ABIInput />;
      case 5:
        return <Step5PolicyMapping />;
      case 6:
        return <Step5_1OnChainConfig />;
      case 7:
        return <Step6Summary />;
      case 8:
        return <Step7Submission />;
      default:
        return <div>Unknown step</div>;
    }
  };

  return (
    <div className="wizard-container" style={{ margin: 0, padding: '0.5rem 0', minHeight: 'auto' }}>
      <div className="wizard-progress-section">
        <div className="wizard-step-indicator">
          Step {currentStep} of {totalSteps}
        </div>
        <div className="wizard-progress-bar">
          <div className="wizard-progress-fill" style={{ width: `${progress}%` }}></div>
        </div>
      </div>

      <div className="wizard-content">{renderStep()}</div>

      {((currentStep < totalSteps) ||
        (currentStep === totalSteps && wizardData.submissionError)) &&
        !(currentStep === totalSteps && wizardData.submissionSuccess) && (
          <div className="wizard-navigation">
            <button
              onClick={prevStep}
              disabled={!canGoBack()}
              className="wizard-btn wizard-btn-back"
            >
              Back
            </button>
            <button
              onClick={nextStep}
              disabled={!canGoNext()}
              className="wizard-btn wizard-btn-next"
            >
              Next
            </button>
          </div>
        )}
    </div>
  );
};

export default Wizard;
